import React, { useEffect, useState } from 'react';

import get from 'lodash.get';
import PropTypes from 'prop-types';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
import { Loader } from 'react-loaders';

import { APP_LABELS } from '@config/app-config';

import { getCampReportsDashboardOverviewData } from '@redux/overnight-camp-data-overview/action';

import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';
import { GetBrachYearWiseReportSelector } from '@redux/overnight-camp-data-overview/selectors';

import OverviewTab from './00-overview';
import CampStaffTab from './01-staff';
import CampParticipationsAndEnrollmentTab from './02-participations-and-enrollment';
import CampFinancialsTab from './03-financials';
import CampProgramAndPropertyTab from './04-program-and-property/index';
import CampReviewAndSubmitTab from './05-review-and-submit';

import SidebarNav from './sidebar-nav';

const OvernightCampForms = props => {
  const {
    location,
    LoginUserData,
    CampReportsDashboardData,
    handleGetCampReportsDashboard
  } = props;

  const { state } = location;
  const statusList = CampReportsDashboardData?.data
    ? CampReportsDashboardData?.data[0]?.dashboardDTOs
    : null;
  const role = get(LoginUserData, 'user.role[0]');
  const branchData = JSON.parse(
    sessionStorage.getItem('yusa_selected_camp_branch')
  );

  const [loader, setLoader] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('v-pills-Overview-tab');

  useEffect(() => {
    const element = document.getElementById(state?.sectionId);
    if (!isDataLoading && element) {
      element?.click();
    }
  }, [isDataLoading, state?.sectionId]);

  useEffect(() => {
    if (state?.selectedYear)
      sessionStorage.setItem('selectedBatchYear', state?.selectedYear);
  }, [state?.selectedYear]);

  useEffect(() => {
    handleGetCampReportsDashboard(
      branchData
        ? branchData?.BranchNumber
        : get(LoginUserData, 'user.branches[0]', null),
      state?.selectedYear
    );
  }, []);

  useEffect(() => {
    sessionStorage.setItem('lastactivetab', activeTab);
    if (activeTab === 'v-pills-Overview-tab') {
      sessionStorage.setItem('dirty', false);
    }
  }, [activeTab]);

  return (
    <BlockUi
      blocking={loader}
      message="Loading, please wait"
      loader={<Loader active type="semi-circle-spin" />}
    >
      <main className="page-container">
        <div className="program-admin-wrapper dashboard-wrapper">
          <div className="container-fluid">
            <section className="dashboard-header">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="d-flex align-items-start ymca-itemArea">
                    <SidebarNav
                      setActiveTab={setActiveTab}
                      setIsDataLoading={setIsDataLoading}
                    />
                    <div
                      className={`tab-content ymca-tabContent ymca-noPad
                    ${
                      (role === APP_LABELS.YUSA_DATA_VIEWER &&
                        activeTab !== 'v-pills-Overview-tab') ||
                      (statusList &&
                        statusList[0]?.status?.toUpperCase() === 'SUBMITTED' &&
                        activeTab !== 'v-pills-Overview-tab')
                        ? 'disable-input-role no-cursor'
                        : ''
                    }`}
                      id="v-pills-tabContent"
                    >
                      <div
                        className="tab-pane ymca-tabPane fade show active"
                        id="v-pills-Overview"
                        role="tabpanel"
                        aria-labelledby="v-pills-Overview-tab"
                      >
                        {activeTab === 'v-pills-Overview-tab' && (
                          <OverviewTab setLoader={setLoader} />
                        )}
                      </div>

                      <div
                        className="tab-pane ymca-tabPane ymca-varientTwo fade"
                        id="v-pills-Staff"
                        role="tabpanel"
                        aria-labelledby="v-pills-Staff-tab"
                      >
                        {activeTab === 'v-pills-Staff-tab' && (
                          <CampStaffTab
                            setLoader={setLoader}
                            status={statusList && statusList[0]?.status}
                          />
                        )}
                      </div>

                      <div
                        className="tab-pane ymca-tabPane ymca-varientTwo fade"
                        id="v-pills-participationsAndEnrollment"
                        role="tabpanel"
                        aria-labelledby="v-pills-participationsAndEnrollment-tab"
                      >
                        {activeTab ===
                          'v-pills-participationsAndEnrollment-tab' && (
                          <CampParticipationsAndEnrollmentTab
                            setLoader={setLoader}
                            status={statusList && statusList[1]?.status}
                          />
                        )}
                      </div>

                      <div
                        className="tab-pane ymca-tabPane fade"
                        id="v-pills-financials"
                        role="tabpanel"
                        aria-labelledby="v-pills-financials-tab"
                      >
                        {activeTab === 'v-pills-financials-tab' && (
                          <CampFinancialsTab
                            setLoader={setLoader}
                            status={statusList && statusList[2]?.status}
                          />
                        )}
                      </div>

                      <div
                        className="tab-pane ymca-tabPane fade"
                        id="v-pills-programAndProperty"
                        role="tabpanel"
                        aria-labelledby="v-pills-programAndProperty-tab"
                      >
                        {activeTab === 'v-pills-programAndProperty-tab' && (
                          <CampProgramAndPropertyTab
                            setLoader={setLoader}
                            status={statusList && statusList[3]?.status}
                          />
                        )}
                      </div>

                      <div
                        className="tab-pane ymca-tabPane ymca-varientTwo fade"
                        id="v-pills-ReviewSubmit"
                        role="tabpanel"
                        aria-labelledby="v-pills-ReviewSubmit-tab"
                      >
                        {activeTab === 'v-pills-ReviewSubmit-tab' && (
                          <CampReviewAndSubmitTab
                            setLoader={setLoader}
                            branchStatus={statusList && statusList[4]?.status}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </BlockUi>
  );
};

OvernightCampForms.propTypes = {
  handleGetCampReportsDashboard: PropTypes.func.isRequired,

  location: PropTypes.objectOf(PropTypes.any).isRequired,
  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  CampReportsDashboardData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = state => ({
  CampReportsDashboardData: GetBrachYearWiseReportSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});
const mapDispatchToProps = {
  handleGetCampReportsDashboard: getCampReportsDashboardOverviewData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OvernightCampForms));
